import React from "react";
import EChartsReact from "@/components/EChartsReact"
import { useSummaryData } from "../hooks/useSummaryData";
import { ClassName_EUIBreakdownkBtuPersqftyr } from "./summaryChartClassnames";

const config = {
    title: 'EUI Breakdown (kBtu/sqft-yr)',
}

export const PieCharts = ({ period, endingMonth }) => {
    const { data: electricityData } = useSummaryData('electricity', period, endingMonth)
    const { data: gasData } = useSummaryData('gas', period, endingMonth)

    const option = {
        backgroundColor: '#fff',
        series: [
            {
                name: 'Nightingale Chart',
                type: 'pie',
                radius: ['0%', '78%'],
                center: ['50%', '55%'],
                itemStyle: {
                    borderRadius: 0
                },
                data: [
                    { value: parseInt(electricityData?.annual_eui || 0), name: 'Electricity', itemStyle: { color: '#69ba5c' } },
                    { value: parseInt(gasData?.annual_eui || 0), name: 'Gas', itemStyle: { color: '#f67e38' } },
                ],
                label: {
                    show: true,
                    position: 'inside',
                    formatter: function (params) {
                        return [
                            `{name|${params.name}}`,
                            `{value|${params.value}}`
                        ].join('\n');
                    },
                    rich: {
                        name: {
                            fontSize: 12,
                            lineHeight: 16,
                            color: '#fff'
                        },
                        value: {
                            fontSize: 14,
                            lineHeight: 16,
                            color: '#fff',
                            fontWeight: 'bold'
                        }
                    }
                },
                labelLine: {
                    show: false
                }
            }
        ],
        legend: {
            show: false,
        },
        title: {
            text: config.title,
            left: 'center',
            top: '2%',
            textStyle: {
                color: '#396598',
                fontSize: 14
            }
        },
    };

    return (

        <EChartsReact className={ClassName_EUIBreakdownkBtuPersqftyr} option={option} style={{ width: '100%', height: '100%' }} />
    );
};